export const isURL = (str) => {
  const pattern = new RegExp(`
  ${"^(https?:\\/\\/)?" /* protocol */}
  ${"((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" /* domain name */}
  ${"((\\d{1,3}\\.){3}\\d{1,3}))" /* OR ip (v4) address */}
  ${"(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" /* port and path */}
  ${"(\\?[;&a-z\\d%_.~+=-]*)?" /* query string */}
  ${"(\\#[-a-z\\d_]*)?$" /* fragment locator */}
  ${"i"}`);
  // const pattern = new RegExp(`^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$`);
  return !!pattern.test(str);
};

export const isIEBrowser = () => {
  return !!document.documentMode;
};

export const createReducer = (schema, reducer) => (
  initialState = schema,
  action$
) => (reducer[action$.type] || (() => initialState))(initialState, action$);

export const buildRouteParams = (route, ...args) => {
  let i = -1;
  const regex = /(:\w+)/g;
  const final = route
    .split(regex)
    .map((chunk) => {
      if (regex.test(chunk)) {
        i += 1;
        return args[i];
      }
      return chunk;
    })
    .join("");
  return final;
};

export const dispatch = (type, payload) => ({ type, payload });

export const objToParams = (obj) =>
  Object.entries(obj)
    .map(
      ([key, value]) => `${key}=${encodeURIComponent(JSON.stringify(value))}`
    )
    .join("&");

export const downloadBlobFile = (content, filename, contentType) => {
  var blob = new Blob([content], { type: contentType });
  var url = URL.createObjectURL(blob);

  var pom = document.createElement("a");
  pom.href = url;
  pom.setAttribute("download", filename);
  pom.click();
};

export const arrayToCsvFormat = (data, headers) => {
  const headerRow = headers.join(",");
  
  const rows = data.map(row => {
    return headers.map(header => {
      const fieldName = header.replace(/ /g, "_");
      const value = row[fieldName] !== undefined ? row[fieldName] : "";
      return `"${String(value).replace(/"/g, '""')}"`;
    }).join(",");
  });

  return [headerRow, ...rows].join("\r\n");
};

/**
 * Get the current API base URL based on selected version
 * @returns {string} The current API base URL
 */
export const getCurrentApiUrl = () => {
  const { getCurrentApiBaseUrl } = require('./constants');
  return getCurrentApiBaseUrl();
};

/**
 * Get the selected API version name
 * @returns {string} The selected API version name
 */
export const getSelectedApiVersion = () => {
  return localStorage.getItem('selected-api-version') || 'galen_cloud';
};

export const isFdaViewEnabled = () => {
  return localStorage.getItem('fdaView') === 'true';
};

export const setFdaView = (enabled) => {
  localStorage.setItem('fdaView', enabled.toString());
};

export const roleMapping = (role) => {
  return {
    "tenantadmin": "Manufacturer Admin",
    "tenantuser": "Manufacturer User",
    "supplieradmin": "Company Admin",
    "supplieruser": "Company User",
    "practiceadmin": "Facility Admin",
    "practiceuser": "Facility User",
    "patient": "Care Team",
    "observe": "Guest",
  }[role.toLowerCase()];
};

export const roleBasedRolesList = (rolesList) => {
  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const role = userDetails !== null ? userDetails.roles[0].role : "";

  if(role === "TenantUser") {
    return rolesList.filter((val) => val.key !== "TenantAdmin" || val.key !== "all");
  } else if(role === "SupplierAdmin") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all"].includes(val.key));
  } else if(role === "SupplierUser") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin"].includes(val.key));
  } else if(role === "PracticeAdmin") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin", "SupplierUser"].includes(val.key));
  } else if(role === "PracticeUser") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin", "SupplierUser", "PracticeAdmin"].includes(val.key));
  } else if(role === "Patient") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser"].includes(val.key));
  } else if(role === "Guest") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser", "Patient"].includes(val.key));
  }
  return rolesList;
};

/**
 * Check if a query parameter exists in the current URL
 * @param {string} paramName - The name of the query parameter to check
 * @returns {boolean} True if the parameter exists, false otherwise
 */
export const hasQueryParam = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(paramName);
};